import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminClinicDetailsPage } from './admin-clinic-details';

@NgModule({
  declarations: [
    AdminClinicDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminClinicDetailsPage),
  ],
})
export class AdminClinicDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-clinic-details/admin-clinic-details.module.ts